<h1 mat-dialog-title>{{title}}</h1>
<p [innerHTML]="message | safeHTML"></p>
<mat-form-field floatPlaceholder="never">
    <input matInput type="number" name="Score" [formControl]="ScoreCtrl" />
    <mat-error *ngIf="ScoreCtrl.hasError('required') && (ScoreCtrl.touched || ScoreCtrl.dirty)">You must enter a numeric value</mat-error>
    <mat-error *ngIf="ScoreCtrl.hasError('pattern') && (ScoreCtrl.touched || ScoreCtrl.dirty)">Value must only contain numbers</mat-error>
</mat-form-field>
<div mat-dialog-actions align="end">
    <button mat-raised-button type="submit" color="primary" (click)="OkHandler()" [disabled]="!ScoreCtrl.valid">{{oktext}}</button>
    <button mat-raised-button type="button" color="warn" (click)="CancelHandler()">{{canceltext}}</button>
</div>


// WEBPACK FOOTER //
// ./src/services/dialogs/edittestthreshold/edittestthreshold.dialogcomponent.html